// MyContext.js
import { createContext, useContext, useState } from "react";

// Create a context with a default value
const MyContext = createContext();

// Create a custom hook to access the context value
export const useMyContext = () => {
  return useContext(MyContext);
};

// Create a context provider component
export const ContextProvider = ({ children }) => {
  const [contextState, setContextState] = useState({
    business: { type: "news", status: "Active" },
    lifestyle: { status: "Active" },
  });

  const updateContextState = (newValue) => {
    setContextState({ ...contextState, ...newValue });
  };

  // Provide the context value to the components in the tree
  return (
    <MyContext.Provider value={{ contextState, updateContextState }}>
      {children}
    </MyContext.Provider>
  );
};
